/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class CartLink extends HTMLElement {
    constructor() {
        super();
        this.itemsCount = this.querySelector("items-count");
    }
    connectedCallback() {
        this.unsubscribe = Cart.subscribe((state => {
            const count = state.cart.item_count.toString();
            if (this.itemsCount) this.itemsCount.textContent = count;
            const link = this.querySelector('[data-cart-label]');
            if (link) link.setAttribute('aria-label', link.dataset.cartLabel + ' (' + count + ')');
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
}

customElements.define("cart-link", CartLink);
//# sourceMappingURL=cart-link.js.map
